import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DevToolsService {
  private showDevTools = signal(false);
  private isConsoleLogEnabled = signal(true);
  private originalConsoleLog = console.log;
  private clickCount = 0;
  private clickTimeout: any;

  constructor() {
    // Guardar referencia original del console.log
    this.originalConsoleLog = console.log;
  }

  // Getters para acceder a los signals
  get devToolsVisible() {
    return this.showDevTools.asReadonly();
  }

  get consoleLogEnabled() {
    return this.isConsoleLogEnabled.asReadonly();
  }

  onLogoClick(): boolean {
    this.clickCount++;
    
    // Resetear el contador después de 2 segundos si no se alcanzan 5 clics
    clearTimeout(this.clickTimeout);
    this.clickTimeout = setTimeout(() => {
      this.clickCount = 0;
    }, 2000);
    
    // Si se alcanzan 5 clics, desbloquear dev tools
    if (this.clickCount >= 5) {
      this.showDevTools.set(true);
      this.clickCount = 0;
      clearTimeout(this.clickTimeout);
      return true;
    }
    
    return false;
  }

  toggleConsoleLog(): void {
    this.isConsoleLogEnabled.update(enabled => !enabled);
    
    if (this.isConsoleLogEnabled()) {
      // Restaurar console.log original
      console.log = this.originalConsoleLog;
      console.log('Console.log habilitado');
    } else {
      // Deshabilitar console.log
      console.log = () => {};
      this.originalConsoleLog('Console.log deshabilitado');
    }
  }

  hideDevTools(): void {
    this.showDevTools.set(false);
  }
}